<template>
    <div :class="[classCol, 'pl-1', $style.__button]">
        <button :type="'reset'" @click="parentFunction" :class="['btn', 'btn-secondary', $style.__cancel]">{{$t('button.cancel')}}</button>
    </div>
</template>

<style lang="scss" module scoped>
   .__button {
        padding-left:0 !important;
        .__cancel {
            font-size: 12px !important;
            font-weight: 500 !important;
            border: 0px solid !important;
            width: 100% !important;
            color: #fff !important;
            line-height: 15px !important;
        }
    }
</style>

<script>
export default {
    props: {
        classCol: {
            default : 'col-6',
            type : String
        },
        event : {
            type : String
        }
    },
    methods : {
        parentFunction : function () {
            this.$emit('parentFunction', true)

        },
    }
}
</script>